module.exports = __webpack_public_path__ + "img/category_prevention_risk_factors.5cbb013.svg";